/** Pending jobs from the public booking form — need office review. */
export const NEW_ONLINE_BOOKING_LABEL = 'New online booking';

export function isNewOnlineBooking(job) {
  if (!job) return false;
  return (
    String(job.lead_source || '').toLowerCase() === 'online_booking' &&
    String(job.status || 'pending').toLowerCase() === 'pending'
  );
}

export function countNewOnlineBookings(jobs) {
  if (!Array.isArray(jobs)) return 0;
  return jobs.filter(isNewOnlineBooking).length;
}

/** Navigate state key for Jobs page filter. */
export const JOBS_FILTER_NEW_ONLINE = 'filterNewOnlineBooking';
